// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner__wrapper[data-v-232410c0]{display:block;position:relative}.banner__image[data-v-232410c0]{bottom:0;left:0;position:absolute;right:0;top:0;z-index:1}.banner__html[data-v-232410c0]{overflow:hidden;position:absolute;z-index:2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
